// StoreTopic.js
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Badge
} from "reactstrap";
import { withTranslation } from "react-i18next";

import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { getLastPage } from 'utils/history';

import { Star, Dot, ArrowLeftFromLine, UserPen, Rss, CircleSlash, ChevronRight } from 'lucide-react';

import './StoreTopic.css';
import VipBadge from "../../components/VipBadge";
import CardCarousel from './components/StoreTopicQuestionSetCardCarousel';

import { uploadImage, fetchImage } from "utils/images/imageManager";

import { useSelector, useDispatch } from "react-redux";
import { selectQuestionSetsForTopic } from "store/selectors";

import home4 from 'assets/images/info/home4.png';
import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import axiosInstance from "utils/axiosInstance";
import BreadcrumbAboveImage from "components/Common/BreadcrumbAboveImage";


/* Store Topic Viewers */
const StoreTopic = ({ t }) => {

  const { topicId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //--------------------------------------------------
  // Breadcrumbs
  //--------------------------------------------------
  const location = useLocation();
  const { themeName, collectionName, topicName } = location.state || {};

  //--------------------------------------------------
  // States
  //--------------------------------------------------

  //const [myInfoTopic, setMyInfoTopic] = useState([]);
  //const [myInfoQuestionSets, setMyInfoQuestionSets] = useState([]);
  //const [backgroundUrl, setBackgroundUrl] = useState("");
  const [isBackgroundUrlLoaded, setIsBackgroundUrlLoaded] = useState(false);
  //const [topicImgUrl, setTopicImgUrl] = useState("");
  const [isTopicUrlLoaded, setIsTopicUrlLoaded] = useState(false);

  //const [imageMap, setImageMap] = useState(new Map());

  const [topicLoading, setTopicLoading] = useState(true);
  const [dataFetchError, setDataFetchError] = useState(null);

  const handlePageBack = () => {

    // Last=Store Page >> Back=Store Page
    // Last=Question Set Input >> Back=Store Page
    // Last=Store Menu >> Back=Store Menu

    const last = getLastPage();
    console.log('previous page:', last);
    if (last==="/myInfo/storeMenu") {
      navigate(last);
    } else {
      navigate(`/myInfo/storeMenu/stores/${myInfoTopic?.storeId}`);
    }

  };



  const {
    topicData,
    loading: topicDetailsLoading,
    error: topicDetailsError,
  } = useSelector(state => ({
    topicData: state.topicDetails.topics[topicId] || {},
    loading: state.topicDetails.loading,
    error: state.topicDetails.error,
  }));

  const imageMap = useSelector(state => state.imageMap);
  useEffect(() => {
    dispatch({ type: 'TOPIC_DETAILS_FETCH_REQUEST', topicId });
  }, [topicId]);

  const {
    topicInfo: myInfoTopic,
  } = topicData;
  const myInfoQuestionSets = useSelector(state => selectQuestionSetsForTopic(state, topicId));
  const topicImgUrl = myInfoTopic?.image;
  const backgroundUrl = myInfoTopic?.backgroundImage;

  useEffect(() => {
    console.log('myInfoTopic:', myInfoTopic);
  }, [myInfoTopic]);


  //--------------------------------------------------
  // Load topic and questionSets on mount
  //--------------------------------------------------
  /*
  const fetchData = async () => {
    try {
      setTopicLoading(true);
      setDataFetchError(null);

      // Load Topic and QuestionSets
      const [topicResponse, questionSetResponse] = await Promise.all([
        axiosInstance.get(`/knovia/myInfo/stores/${topicId}/getStoreTopicInfo`),
        axiosInstance.get(`/knovia/myInfo/stores/${topicId}/getQuestionSetsInStoreTopic`)
      ]);

      console.log('Topic Loaded:', topicResponse.data);
      setMyInfoTopic(topicResponse.data);

      console.log('QuestionSets in Topic Loaded:', questionSetResponse.data);
      // Sort by `order` before setting state
      const sortedQuestionSets = [...questionSetResponse.data].sort(
        (a, b) => a.order - b.order
      );
      setMyInfoQuestionSets(sortedQuestionSets);

      return {
        topic: topicResponse.data,
        sortedQuestionSets,
      };
    } catch (err) {
      console.error(err);
      setDataFetchError("Failed to load data.");
      return null; // <- This ensures the caller knows the fetch failed
    } finally {
      setTopicLoading(false);
    }
  };

  const fetchTopicImages = async (topic) => {
    try {

      const topicBackgroundPromise = topic?.backgroundImage
        ? fetchImage(topic.backgroundImage, "original")
        : Promise.resolve(null);

      const topicImgPromise = topic?.image
        ? fetchImage(topic.image, "original")
        : Promise.resolve(null);

      if (!topic?.backgroundImage) { setIsBackgroundUrlLoaded(true); }
      if (!topic?.image) { setIsTopicUrlLoaded(true); }

      const [backgroundUrl, topicUrl] = await Promise.all([
        topicBackgroundPromise,
        topicImgPromise,
      ]);

      setIsBackgroundUrlLoaded(true);
      setIsTopicUrlLoaded(true);

      console.log('topic.image:', topic.image);
      console.log('topicUrl:', topicUrl);

      if (backgroundUrl) setBackgroundUrl(backgroundUrl);
      if (topicUrl)  setTopicImgUrl(topicUrl);
    } catch (err) {
      console.error("Error fetching topic images:", err);
    }
  };


  const fetchQuestionSetThumbnails = async (sortedQuestionSets) => {
    const newMap = new Map(imageMap); // preserve existing

    await Promise.all(
      sortedQuestionSets.map(async (entry) => {
        const filename = entry.image;
        if (!filename || newMap.has(filename)) return;

        try {
          const url = await fetchImage(filename, "original");
          newMap.set(filename, url);
        } catch (e) {
          console.error("Failed to load image:", filename);
        }
      })
    );
    console.log("newMap:", newMap);
    setImageMap(newMap);

  };

  useEffect(() => {
    (async () => {
      const { topic, sortedQuestionSets } = await fetchData();
      if (!topic) return;

      if (topic) {
        fetchQuestionSetThumbnails(sortedQuestionSets);
        fetchTopicImages(topic);
      }
    })();
  }, [topicId]);
  */


  //--------------------------------------------------
  // Follow and Unfollow
  //--------------------------------------------------
  /*
  const handleFollow = async () => {
    try {
      const response = await axiosInstance.post(`/knovia/myInfo/stores/${myInfoTopic?._id}/followTopic`);
      setMyInfoTopic(prev => ({
        ...prev,
        isFollowing: true,
        followerCount: (prev.followerCount || 0) + 1
      }));
      console.log("Follow successful:", response.data);
    } catch (error) {
      if (error.response?.status === 409) {
        console.log("Already followed.");
      } else {
        console.error("Failed to follow store topic:", error);
      }
    }
  };

  const handleUnfollow = async () => {
    try {
      const response = await axiosInstance.delete(`/knovia/myInfo/stores/${myInfoTopic?._id}/unfollowTopic`);
      setMyInfoTopic(prev => ({
        ...prev,
        isFollowing: false,
        followerCount: Math.max((prev.followerCount || 1) - 1, 0)
      }));
      console.log("Unfollowed successfully:", response.data);
    } catch (error) {
      console.error("Failed to unfollow store topic:", error);
    }
  };
  */

  const handleFollow = async () => {
    try {
      const response = await axiosInstance.post(`/knovia/myInfo/stores/${myInfoTopic?._id}/followTopic`);
      dispatch({
        type: 'UPDATE_TOPIC_FOLLOW_STATUS',
        payload: {
          topicId,
          isFollowing: true,
          followerCount: (myInfoTopic?.followerCount || 0) + 1,
        }
      });
      console.log("Follow successful:", response.data);
    } catch (error) {
      if (error.response?.status === 409) {
        console.log("Already followed.");
      } else {
        console.error("Failed to follow store topic:", error);
      }
    }
  };

  const handleUnfollow = async () => {
    try {
      const response = await axiosInstance.delete(`/knovia/myInfo/stores/${myInfoTopic?._id}/unfollowTopic`);
      dispatch({
        type: 'UPDATE_TOPIC_FOLLOW_STATUS',
        payload: {
          topicId,
          isFollowing: false,
          followerCount: Math.max((myInfoTopic?.followerCount || 1) - 1, 0),
        }
      });
      console.log("Unfollowed successfully:", response.data);
    } catch (error) {
      console.error("Failed to unfollow store topic:", error);
    }
  };


  //--------------------------------------------------
  // Return
  //--------------------------------------------------

  return (

    <div className="page-content store-topic-list" 
      style={{ "--page-content-background": `url(${home4})` }}
    >

      <Container fluid className="store-topic-list-container">

        <div className="store-topic-list-breadcrumb">
          <BreadcrumbAboveImage 
            title={t("My Info")}
            breadcrumbItems={[
              { title: t("我的 AI 應用主頁"), to: "/myInfo/dashboard" },
              { title: t("..."), to: "/myInfo/navigateThemes" },
              { 
                title: t(`${myInfoTopic?.infoCollection?.theme?.label || themeName || ""}`), 
                to: `/myInfo/themes/${myInfoTopic?.infoCollection?.theme?._id || ""}`
              },
              { 
                title: t(`${myInfoTopic?.infoCollection?.label || collectionName || ""}`), 
                to: `/myInfo/collections/${myInfoTopic?.infoCollection?._id || ""}`
              },
              { title: t(`${myInfoTopic?.label || topicName}`)}
            ]}
          />
          </div>

          <div className="d-block d-md-none">
            {/* Collection Image at top */}
            <div 
              /*className={`store-topic-top-image ${isBackgroundUrlLoaded ? 'fade-in' : ''}`}*/
              className={`store-topic-top-image`}
              style={{
                backgroundImage: `url(${imageMap[backgroundUrl] || placeholder_image})`,
              }}
            >
            </div>

            <div className="store-topic-page-back-div">
              <Button
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "5px",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                  background: "#55535373"
                }}
                onClick={handlePageBack}
              >
                <ArrowLeftFromLine size={24} />
              </Button>
            </div>
          </div>

          <Card className="store-topic-list-card">
            <CardBody className="store-topic-list-card-body">


              {/*------ Small Screen ------*/}
              <div className="d-block d-md-none">

                {/* Topic Thumbnail */}
                <div 
                  /*className={`store-topic-thumbnail ${isTopicUrlLoaded ? 'fade-in' : ''}`}*/
                  className={`store-topic-thumbnail`}
                  style={{
                    backgroundImage: `url(${imageMap[topicImgUrl] || placeholder_image})`,
                  }}
                >
                </div>

                <div 
                  className="d-flex align-items-center"
                  style={{
                    position: "absolute",
                    top: "15px",
                    right: "18px",
                    height: "18px",
                    fontSize: "11px",
                    cursor: "pointer",
                    padding: "0px 1px 0px 1px",
                    /*borderBottom: "1px solid #4988d8",*/
                    userSelect: 'none',
                    maxWidth: "28vw"
                  }}
                  onClick={()=>{ navigate(`/myInfo/storeMenu/stores/${myInfoTopic?.storeId}`); }}
                >
                  <p className="mb-0"
                    style={{
                      marginRight: "2px",
                      color: "#4988d8",
                      textAlign: "right"
                    }}
                  >
                    {myInfoTopic?.storeName?.length > 15 ? myInfoTopic?.storeName.slice(0,15)+"..." : myInfoTopic?.storeName}
                  </p>
                  <ChevronRight size={14} stroke="#4988d8" style={{ marginTop: '1.5px' }}/>
                </div>

                {/* Store Topic Label */}
                <Row className="mb-1">
                  <Col className="store-topic-label">
                    {/*
                    <div style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100px",
                      borderBottom: "0.5px solid #4988d8",
                      marginBottom: "10px",
                      paddingBottom: "1px"
                    }}>
                      <p className="mb-0" style={{ fontSize: "11.5px", color: "#7ba2d4" }}>主題</p>
                    </div>
                    */}
                    <div className="d-flex flex-column"
                      style={{ maxWidth: "80%" }}
                    >
                      <p className="mb-0" style={{ fontSize: "10.5px", color: "#4988d8", paddingLeft: "0.3px" }}>主題</p>
                      <p className="mb-0" style={{ marginTop: "-3px" }}>{`${myInfoTopic?.label || '--'}`}</p>
                    </div>
                  </Col>
                </Row>

                {/* Store Topic Description */}
                {myInfoTopic?.description && (
                  <Row>
                    <Col className="store-topic-description">
                      <p className="mb-0" style={{ maxWidth: "70%", fontSize: "13.5px", color: "#848282" }}>
                        {myInfoTopic?.description}
                      </p>
                    </Col>
                  </Row>
                )}

                {/* Star and VIP level */}
                <Row>
                  <Col className="store-topic-star-col">
                    <div className="d-flex">
                      <p className="mb-0">4.9</p>
                      <Star size={18} fill="#faca82" stroke="none"
                        style={{ margin: '1.8px 2px 0px 2px' }}
                      />
                      {/* A filled star */}
                      <p className="mb-0 text-muted">(400+)</p>
                    </div>
                    <div>
                      <Dot size={16} /> {/* You can also use a styled div for a smaller solid dot */}
                    </div>
                    <div style={{ marginTop: "-6px" }}>
                      <VipBadge vipLevel="VIP1" imageSize={35} textSize={42} />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: "30px" }}>
                  <Col className="store-topic-filled-count-col">
                    <Button className="me-2" color="soft-info" style={{
                      height: "30px",
                      paddingTop: "3.5px"
                    }}>
                      1000+ 人已填寫此主題
                    </Button>

                    <Button color="soft-success" style={{
                      height: "30px",
                      paddingTop: "3.5px"
                    }}>
                      {myInfoTopic?.followerCount || 0}+ 人已追蹤
                    </Button>
                  </Col>
                </Row>

              </div>


              {/* Follow */}
              <div className="d-flex justify-content-center" style={{ marginBottom: "30px" }}>
                <div className="d-flex flex-column align-items-center"
                  style={{ cursor: "pointer", userSelect: "none" }}
                  onClick={myInfoTopic?.isFollowing ? handleUnfollow : handleFollow}
                >
                  {myInfoTopic?.isFollowing ? (
                    <>
                      <CircleSlash size={32} strokeWidth={1.5} />
                      <p className="mb-0" style={{ marginTop: "1px" }}>取消追蹤主題</p>
                    </>
                  ) : (
                    <>
                      <Rss size={32} strokeWidth={1.5} />
                      <p className="mb-0" style={{ marginTop: "1px" }}>追蹤主題</p>
                    </>
                  )}
                </div>
              </div>


              {/*------ Big Screen ------*/}
              <div className="d-none d-md-block">
                <Row style={{ 
                  paddingTop: "25px",
                  paddingBottom: "25px", 
                  /*backgroundColor: "#f0f0f0",*/
                  background: "linear-gradient(160deg, #91cdff 0%, white 50%)",
                  margin: "0", 
                  borderRadius: "4px 4px 0 0" 
                }}>
                  <Col md={6} className="d-flex justify-content-center">
                    {/* Collection Image at top */}
                    <div className="question-set-top-image"
                      style={{
                        backgroundImage: `url(${backgroundUrl || placeholder_image})`,
                      }}
                    >
                      {/* Topic Thumbnail */}
                      <div className="store-topic-thumbnail"
                        style={{
                          backgroundImage: `url(${topicImgUrl || placeholder_image})`,
                        }}
                      >
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    {/* Topic Label */}
                    <Row>
                      <Col className="d-flex flex-column store-topic-label"
                        style={{ padding: "15px 0px 0px 0px" }}
                      >
                        <p style={{ marginBottom: "8px" }}>{myInfoTopic?.label}</p>
                        <div style={{ maxWidth: "70%" }}>
                          <p className="mb-0 text-muted" style={{ fontSize:'13.5px' }}>
                            實用的造型工具，透過加熱金屬棒捲曲頭髮，能創造自然捲度與蓬鬆感，是日常快速整理髮型的好幫手。
                          </p>
                        </div>
                      </Col>
                    </Row>

                    {/* Star and VIP level */}
                    <Row>
                      <Col className="store-topic-star-col">
                        <div className="d-flex">
                          <p className="mb-0">4.9</p>
                          <Star size={16} fill="black" strokeWidth="none"
                            style={{ margin: '3px 2px 0px 2px' }}
                          />
                          {/* A filled star */}
                          <p className="mb-0 text-muted">(400+)</p>
                        </div>
                        <div style={{ margin: '0px 2px 0px 5px' }}>
                          <Dot size={16} /> {/* You can also use a styled div for a smaller solid dot */}
                        </div>
                        <div style={{ marginTop: "-6px" }}>
                          <VipBadge vipLevel="VIP1" imageSize={35} textSize={42} />
                        </div>
                      </Col>
                    </Row>

                    <Row style={{ marginBottom: "30px" }}>
                      <Col className="store-topic-filled-count-col">
                        <div className="d-flex flex-column flex-lg-row" style={{
                          justifyContent: "space-between", width: "80%"
                        }}>
                          <div className="mb-2 mb-lg-0">
                            <Button color="soft-success" 
                              style={{
                                height: "30px",
                                paddingTop: "3.5px"
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                e.currentTarget.blur();
                                return false;
                              }}
                            >
                              1000+ 人已填寫此主題
                            </Button>
                          </div>

                          <div className="d-flex store-topic-author-div">
                            <UserPen size={24} strokeWidth={1.25} color="#5086b3" />
                            <p className="store-topic-author mb-0">TTMY_Admin</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>

              </div>




              <div className="section-div" />

              {/*------ Small Screen ------*/}
              <div className="d-block d-md-none">
                {/* QuestionSet Carousel */}
                <Row>
                  <Col className="store-topic-filled-carousel-col">
                    <div style={{ paddingLeft: "25px" }}>
                      <p className="mb-0 question-set-section-title">所有題組</p>
                    </div>
                    <CardCarousel 
                      cards={myInfoQuestionSets}
                      imageMap={imageMap}
                    />
                  </Col>
                </Row>

                <div className="section-div" style={{ margin: "30px 0px 0px 0px" }}/>
              </div>


              {/*------ Big Screen ------*/}
              <div className="d-none d-md-block">
                {/* QuestionSet Carousel */}
                <Row style={{ padding: "0px 0px 0px 0px", margin: '0px' }}>
                  <Col className="store-topic-filled-carousel-col"
                    style={{ padding: "30px 0px 60px 50px" }}
                  >
                    <div style={{ paddingLeft: "25px" }}>
                      <p className="mb-0 question-set-section-title">所有題組</p>
                    </div>
                    <CardCarousel 
                      cards={myInfoQuestionSets}
                      imageMap={imageMap}
                    />
                  </Col>
                </Row>
              </div>


            </CardBody>
          </Card>

      </Container>
    </div>
  );
};

export default withTranslation()(StoreTopic);


